import i18n from "@i18n/i18n";
import { GridAggregationFunction } from "@mui/x-data-grid-premium";

/*
 * This is a custom aggregation function that checks if all the child items in the column are true.
 */
const truthyAgg: GridAggregationFunction<unknown, boolean> = {
  apply: (params) => {
    let truthy = true;
    for (let i = 0; i < params.values.length; i += 1) {
      const value = params.values[i];
      if (value !== true) {
        truthy = false;
      }
    }

    return truthy;
  },
  columnTypes: ["boolean"],
};

const sumWithNullsAgg: GridAggregationFunction<unknown, number | null> = {
  apply: ({ values }) => {
    let sum: number | null = null;
    for (let i = 0; i < values.length; i += 1) {
      const value = values[i];
      if (typeof value === 'number' && !Number.isNaN(value)) {
        sum = value + (sum || 0);
      }
    }


    return sum;
  },
  columnTypes: ['number'],
};

// Compare all text values for equality and return the value if they are all the same
// Otherwise if they are different, return '<Varies>'
// If there are no text values, return null
// For footer row (root level aggregation), return empty string
const textComparatorAgg: GridAggregationFunction<unknown, string | null> = {
  apply: (params) => {
    // Return empty string for footer row (root level aggregation)
    if (params.groupId === 'auto-generated-group-node-root') {
      return '';
    }

    let firstValue: string | null = null;

    for (let i = 0; i < params.values.length; i += 1) {
      const value = params.values[i];
      if (typeof value === 'string' && value.trim() !== '') {
        if (firstValue === null) {
          firstValue = value;
        } else if (firstValue !== value) {
          return i18n.t("data-grid.aggregation.varies");
        }
      }
    }

    return firstValue;
  },
  columnTypes: ['string'],
};

// Compare all number values for equality and return the value if they are all the same
// Otherwise if they are different, return '<Varies>'
// If there are no text values, return null
const numberComparatorAgg: GridAggregationFunction<unknown, number | string | null> = {
  apply: ({ values }) => {
    let firstValue: number | null = null;

    for (let i = 0; i < values.length; i += 1) {
      const value = values[i];
      if (typeof value === 'number' && !Number.isNaN(value)) {
        if (firstValue === null) {
          firstValue = value;
        } else if (firstValue !== value) {
          return i18n.t("data-grid.aggregation.varies");
        }
      }
    }

    return firstValue;
  },
  columnTypes: ['number'],
};

export { numberComparatorAgg, sumWithNullsAgg, textComparatorAgg, truthyAgg };

